:host {
  display: block;
}

.callout {
  display: flex;
  background-color: var(--aha-gray-100);
  border-radius: var(--Common--border-radius);
  align-items: center;
  padding: var(--spacer-4);
  box-sizing: border-box;
}

.callout .content {
  margin-left: var(--spacer-5);
  width: 100%;
}

.callout .content .header {
  font-weight: 600;
  display: flex;
  align-items: center;
  font-size: var(--font-size-100);
}

.callout .content .header aha-promo-try-pill {
  margin-left: var(--spacer-2);
}

.callout .content .header.header--small {
  font-size: var(--font-size-200);
}

.callout .content .description {
  color: var(--theme-secondary-text);
  margin: var(--spacer-2) 0;
  max-width: min(80vw, 600px);
  font-size: var(--font-size-100);
}

.callout .content .description.description--small {
  font-size: var(--font-size-300);
}

.callout .content aha-button {
  float: right;
}
